"use client";
import { useWindowWidth } from "./dim-hook";
import { mobileHeaderBreakPoint } from "@/utils/functions/global-constants";

export const useIsMobile = () => {
  const w = useWindowWidth();
  return w <= mobileHeaderBreakPoint;
};
